import styled from 'styled-components';
import { Styling } from '../../../constants';

export const ProgressContainer = styled.div`
  height: ${Styling.DEFAULT_LINEAR_PROGRESS_HEIGHT}px;
`;

export const UserListContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;
  padding: ${Styling.DEFAULT_SPACING}px;
  font-size: 14px;
`;

export const UserContainer = styled.div`
  padding: 5px 0;
  font-size: 16px;
`;
